import { useSelector } from 'react-redux'
import { RootState } from '../redux/store'

export const useRole = () => {
	const userData = useSelector((state: RootState) => state.auth.userData)
	const userRole = userData?.role

	const isAdmin = () => userRole === 'ADMIN_ROLE'
	const isUser = () => userRole === 'USER_ROLE'
	const isAudit = () => userRole === 'AUDIT_ROLE'
	
	const canManageUsers = () => isAdmin()
	const canCreateUser = () => isAdmin()
	const canWrite = () => isAdmin() || isUser()
	const canRead = () => isAdmin() || isUser() || isAudit()

	return {
		userRole,
		isAdmin,
		isUser,
		isAudit,
		canManageUsers,
		canCreateUser,
		canWrite,
		canRead
	}
}

export default useRole
